import { createRouter, createWebHistory } from "vue-router";
// import Home from "../views/Home.vue";

// import NotFound from "../views/NotFound.vue";

const routes = [
	// { path: "/:id", name: "Home", component: Home, alias: '/index.html' },
	
	// { path: "/:catchAll(.*)", name: "404",component: NotFound,props: { footer: true, header: true, footerArticles: true }},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	base: process.env.BASE_URL,
	routes,

	scrollBehavior(/*to, from, savedPosition*/) {
		return new Promise((resolve/*, reject*/) => {
		setTimeout(() => {
			resolve({ left: 0, top: 0 })
		}, 200)
		})
	},
});

export default router;
